import { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { useTypes } from '@/framework/type';
import { TYPES_PER_PAGE } from '@/framework/client/variables';
import { ArrowNext, ArrowPrev } from '../icons';
import Link from '../ui/link';

const CategoriesRowMobile = () => {
  const { types }: any = useTypes({
    limit: TYPES_PER_PAGE,
  });

  const filteredTypes = types?.filter((type: any) => type.id !== 20) || [];

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <div
      id="categories-row"
      className="flex lg:hidden w-full justify-center px-5 pb-2 relative bg-primary"
    >
      <div className="flex w-full items-center relative">
        {/* Custom Arrows */}
        <button
          type="button"
          ref={prevRef}
          aria-label="Categorias anteriores"
          className="z-10 flex h-6 w-6 shrink-0 items-center justify-center text-white transition-colors"
        >
          <ArrowPrev className="w-4 h-4" aria-hidden="true" />
        </button>

        <Swiper
          modules={[Navigation]}
          spaceBetween={12}
          slidesPerView="auto"
          navigation={{
            prevEl: prevRef.current!,
            nextEl: nextRef.current!,
            disabledClass: 'swiper-button-disabled',
          }}
          onSwiper={(swiper) => {
            // @ts-ignore
            swiper.params.navigation.prevEl = prevRef.current;
            // @ts-ignore
            swiper.params.navigation.nextEl = nextRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
          }}
          className="w-full"
        >
          {filteredTypes.map((type: any) => (
            <SwiperSlide key={type.id} style={{ width: 'auto' }}>
              <Link
                href={`/${type?.slug}/${type?.id}`}
                className="text-white whitespace-nowrap hover:text-accent hover:bg-white px-3 py-1 rounded-xl transition-colors text-sm font-medium"
              >
                {type.name}
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>

        <button
          type="button"
          ref={nextRef}
          aria-label="Próximas categorias"
          className="z-10 flex h-6 w-6 shrink-0 items-center justify-center text-white transition-colors"
        >
          <ArrowNext className="w-4 h-4" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
};

export default CategoriesRowMobile;
